import { render, staticRenderFns } from "./OpenBlock.vue?vue&type=template&id=397ff1c3"
import script from "./OpenBlock.vue?vue&type=script&lang=js"
export * from "./OpenBlock.vue?vue&type=script&lang=js"
import style0 from "./OpenBlock.vue?vue&type=style&index=0&id=397ff1c3&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports